import React from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { useLanguage } from '../contexts/LanguageContext';

const ChatInput = ({ input, setInput, handleSend, isLoading }) => {
  const { tr } = useLanguage();
  // Function to auto-resize the textarea based on content
  const handleTextAreaChange = (e) => {
    const textarea = e.target;
    setInput(textarea.value);
    
    // Reset height to auto to properly calculate the new height
    textarea.style.height = 'auto';
    
    // Set new height based on scrollHeight (with a max height)
    const newHeight = Math.min(textarea.scrollHeight, 150);
    textarea.style.height = `${newHeight}px`;
  };

  return (
    <TextField
      fullWidth
      variant="standard"
      placeholder={tr('請輸入您的問題...', 'Type your response…')}
      value={input}
      onChange={handleTextAreaChange}
      onKeyDown={(e) => {
        // Submit on Enter (without Shift)
        if (e.key === 'Enter' && !e.shiftKey && !isLoading) {
          e.preventDefault();
          handleSend();
        }
        // Cancel on Escape
        if (e.key === 'Escape') {
          e.preventDefault();
          setInput(''); // Clear input when in edit mode
        }
      }}
      multiline
      maxRows={6}
      InputProps={{
        disableUnderline: true,
        sx: {
          px: 2,
          py: 1,
          '& textarea': {
            color: '#333',
            resize: 'none',
            overflow: 'auto',
            minHeight: '24px',
            lineHeight: '1.5',
          }
        },
        // Add send button as an adornment for mobile users
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={handleSend}
              disabled={!input.trim() || isLoading}
              sx={{ 
                display: { xs: 'flex', sm: 'none' },
                color: input.trim() && !isLoading ? 'primary.main' : 'text.disabled'
              }}
            >
              <SendIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        )
      }}
      sx={{
        '& .MuiInputBase-root': {
          backgroundColor: 'background.paper',
        }
      }}
    />
  );
};

export default ChatInput;
